import {gettext} from '../../state/gettext-extract-util';

/**
 * return string indicate range boundary type
 * @param {*} min range min
 * @param {*} max  range max
 */
const getRangeType = (min, max) => {
  if (min && max) {
    return 'between';
  } else if (max) {
    return 'within';
  } else if (min) {
    return 'outside';
  } else {
    return '';
  }
};
const daysRange = (min, max) => {
  return {
    min,
    max,
    type: getRangeType(min, max)
  };
};

export const LastSeenOptions = [
  {
    label: gettext('within 24h'),
    id: 'seen-24h',
    range: daysRange(0, 1)
  },
  {
    label: gettext('1-3 Days'),
    id: 'seen-1-3d',
    range: daysRange(1, 3)
  },
  {
    label: gettext('3-10 Days'),
    id: 'seen-3-10d',
    range: daysRange(3, 10)
  },
  {
    label: gettext('10-30 Days'),
    id: 'seen-in-10-30d',
    range: daysRange(10, 30)
  },
  {
    label: gettext('30+ Days'),
    id: 'not-seen-30d',
    range: daysRange(30, null)
  }
];

const customOption = (min, max) => {
  return {
    id: 'custom',
    range: daysRange(min || 0, max)
  };
};

const isSame = (a, b) => {
  //will cast ( 0, undefined,'') to null as they are all same in the range
  a = a || null;
  b = b || null;
  return a === b;
};

export const getLastSeenOptionByMinMax = (minValue, maxValue) => {
  const matchOption = LastSeenOptions.find(
    option => isSame(option.range.max, maxValue) && isSame(option.range.min, minValue)
  );
  return matchOption ? matchOption : customOption(minValue, maxValue);
};
